/* eslint-disable no-underscore-dangle */
import React from 'react'

import { getFlexersForPrefix } from 'components/shared/flexContentRegistry'

interface FlexContentProps {
  prefix?: string
  fields: any
  location?: any
}

interface ComponentProps {
  fields: any
  location?: any
}

const FlexContentHandler: React.FC<FlexContentProps> = ({
  prefix = 'page_Flexcontent',
  fields,
  location = {},
}) => {
  if (!fields) {
    return null
  }

  const includeHomeBlocks =
    Boolean(fields.homeTemplate) || prefix !== 'Vacancy_Flexcontent'
  const flexers = getFlexersForPrefix(prefix, includeHomeBlocks)

  if (fields.homeTemplate) {
    // eslint-disable-next-line
    fields.flex = fields.flexHome
  }

  if (!fields.flex) {
    return null
  }

  return (
    <>
      {fields.flex.map((section: any, index: number) => {
        if (!section.fieldGroupName || !flexers[section.fieldGroupName]) {
          return null
        }

        const Component: React.FC<ComponentProps> =
          flexers[section.fieldGroupName]

        return (
          <Component
            // eslint-disable-next-line react/no-array-index-key
            key={`${location ? location.pathname : 'flex'}-${index}`}
            fields={section}
            location={location}
          />
        )
      })}
    </>
  )
}

export default FlexContentHandler
